import React, { useEffect } from 'react';
import {Button, Card, CardContent, Dialog, Grid, Slide, Typography} from '@mui/material/';
import Icon from '@mui/material/Icon';
import useStyles from './styles';
import useButtonStyles from 'styles/button';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});


function ModalDeConfirmacion({title, message, open, closeModal, titleButton, titleButtonClose, disableBackdropClick, disableEscapeKeyDown, actionAdd, showSecondButton, actionAdd2, titleButton2}) {
    let buttonYes = React.createRef();
    const classes = useStyles();
    const buttonStyles = useButtonStyles();

    useEffect(() => {
        if (buttonYes.current!==null)
            buttonYes.current.focus();
    });

    return (
        <div>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                keepMounted
                onClose={()=>closeModal(false)}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                disablebackdropclick={disableBackdropClick}
                disableEscapeKeyDown={disableEscapeKeyDown}
            >
                <Card >
                    <CardContent >
                        <Grid  container justify="center" alignItems="center" spacing={1} >
                            <Icon color={"primary"} className={buttonStyles.icon}>
                                errorOutline
                            </Icon>
                            <Typography className={classes.title} >
                                {title}
                            </Typography>
                            <Typography className={classes.description} >
                                {message}
                            </Typography>
                        </Grid>
                        <Grid container justifyContent="center" alignItems="center" flexDirection={"column"} spacing={1}>
                            <Button variant="contained" onClick={()=>actionAdd(true)} className={buttonStyles.button} ref={buttonYes}>{titleButton}</Button>
                            {showSecondButton && (
                                <Button variant="contained" onClick={()=>actionAdd2(true)} className={buttonStyles.button} ref={buttonYes}>{titleButton2}</Button>
                            )}
                            <Button variant="contained" onClick={()=>closeModal(false)} className={buttonStyles.buttonCancel} >{titleButtonClose}</Button>
                        </Grid>
                    </CardContent>
                </Card>
            </Dialog>
        </div>
    );
}

ModalDeConfirmacion.defaultProps = {
    title: "Mensaje de confirmación",
    titleButton: "Sí, Agregar",
    titleButtonClose: "No, Cancelar",
    disableBackdropClick: "true",
    disableEscapeKeyDown: true,
    showSecondButton:false,
    actionAdd2: () => {},
    titleButton2: "",
};

export default ModalDeConfirmacion;